<div id="wrapper" [style.height]="((transferProcesses$ | async)?.length ?? 0) === 0 ? 'calc(100% - 98px)' : 'auto'">
  <!-- <mat-card>
      <div class="info-box">
        <mat-icon>info</mat-icon>
        <span class="text">Please install Storage Explorer for visualizing files transferred to Azure Blob Storage</span>
        <span class="button">
          <a mat-stroked-button href="https://azure.microsoft.com/features/storage-explorer/" color="accent">Install Azure Storage Explorer</a>
        </span>
      </div>
    </mat-card> -->

  <div class="container">
    <button mat-flat-button (click)="loadTransferProcesses()" color="accent">
      <mat-icon>cached</mat-icon>
      Refresh
    </button>
  </div>

  <ng-container *ngIf="transferProcesses$ | async as transferProcesses">
    <div *ngIf="transferProcesses.length === 0" class="empty-wrapper">
      <div class="no-assets-message">
        <mat-icon style="font-size: 64px; width: 64px; height: 64px;">history</mat-icon>
        <h2>No transfer history available</h2>
        <p>The connector doesn't have transfer processes yet.</p>
        <p>Use Refresh or start a transfer to see entries here.</p>
      </div>
    </div>
  </ng-container>


  <ng-container *ngIf="transferProcesses$ | async as transferProcesses">
    <table *ngIf="transferProcesses.length > 0" mat-table [dataSource]="transferProcesses"
      class="transfer-history-table">
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef scope="col">Type</th>
        <td mat-cell *matCellDef="let item">
          <mat-icon *ngIf="item.type === 'CONSUMER'" class="consumer-icon">arrow_downward</mat-icon>
          <mat-icon *ngIf="item.type === 'PROVIDER'" class="provider-icon">arrow_upward</mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef scope="col">Id</th>
        <td mat-cell *matCellDef="let item">{{item.id}}</td>
      </ng-container>

      <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef scope="col">State</th>
        <td mat-cell *matCellDef="let item">{{item.state}}</td>
      </ng-container>

      <ng-container matColumnDef="lastUpdated">
        <th mat-header-cell *matHeaderCellDef scope="col">Last updated</th>
        <td mat-cell *matCellDef="let item">{{asDate(item.mandatoryValue('edc', 'stateTimestamp'))}}</td>
      </ng-container>

      <ng-container matColumnDef="assetId">
        <th mat-header-cell *matHeaderCellDef scope="col">AssetId</th>
        <td mat-cell *matCellDef="let item">{{item.assetId}}</td>
      </ng-container>

      <ng-container matColumnDef="contractId">
        <th mat-header-cell *matHeaderCellDef scope="col">ContractId</th>
        <td mat-cell *matCellDef="let item">{{item.contractId}}</td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef scope="col">Actions</th>
        <td mat-cell *matCellDef="let item" class="singleline-cell">
          <!-- <a *ngIf="true || showStorageExplorerLink(item)" mat-stroked-button mat-button color="accent" [href]="storageExplorerLinkTemplate | replace: item['edc:dataDestination'].properties | safe: 'url'" class="action-button">
                <mat-icon>loupe</mat-icon> Open Storage Explorer
              </a> -->
          <button *ngIf="showDeprovisionButton(item)" tabindex="-1" (click)="onDeprovision(item)" color="warn"
            mat-stroked-button class="action-button">
            <mat-icon>cancel</mat-icon> Deprovision
          </button>
          <button *ngIf="showGetData(item)" tabindex="-1" (click)="onGetData(item)" color="accent" mat-flat-button
            class="action-button">
            <mat-icon>check_circle</mat-icon> Get Data
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns" class="transfer-history-table-header"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;"></tr>
    </table>

    <mat-paginator style="width: 100%;" *ngIf="transferProcesses.length"
      [length]="transferProcesses.length" pageSize="transferProcesses.length" hidePageSize="true"></mat-paginator>

  </ng-container>

</div>